import { Gender } from "../../../../../../../server/models/shared";
import { Category } from "../../../../../../../server/models/category";

export const categoryToConditionProps: (category: Category) => { label: string; value: string }[] = (category) => {
	return [
		{ label: "性別", value: Gender[category.gender] },
		{ label: "年齢", value: "15～69歳" },
	];
};
